export default "__VITE_ASSET__zRVtfEl8__"